import { Filter } from '@fabric-ui/components';
import { SettingType } from '../hooks';

export const GroupingRuleSetTypes = {
  Finding: 'uber_findings',
  Alert: 'uber_alerts',
  Ticket: 'tickets',
  Incident: 'incidents',
  Violation_Tickets: 'violation_tickets',
  Policy_Violations: 'uber_policy_violations',
} as const;

export const supportedProjections = {
  Violation_Tickets: 'violation_tickets',
  Ticket: 'tickets',
};

export const GroupingRuleToTypes = {
  [GroupingRuleSetTypes.Finding]: 'tickets',
  [GroupingRuleSetTypes.Alert]: 'incidents',
};

export const SubAutoComplete = {
  [GroupingRuleSetTypes.Alert]: 'uber_alert_actors',
};

export const DEFAULT_RULE_NAME = 'Default';

export const NEW_RULE_SET_ID = 'create';

export const NEW_RULE_ID = 'create-rule';

export const NEW_DEFAULT_RULE_ID = 'default-rule';

type FieldGrouping = {
  fields: string[];
};

type Grouping = {
  fieldGrouping: FieldGrouping;
};

export type GroupingRule = {
  name: string;
  ruleOrder?: number;
  condition?: Filter;
  grouping?: Grouping;
  id?: string;
  createdAt?: string;
  createdUserId?: string;
  updatedAt?: string;
  updatedUserId?: string;
  entityTitleFormat: string;
  defaultFallbackRule?: boolean;
  isNew?: boolean;
  entityTitleFormulaType?: FormulaType;
};

export type GroupingRulesSet = {
  createdAt: string;
  createdByUserId: string;
  entityType: string;
  name: string;
  isActive: boolean;
  rules: GroupingRule[];
  id: string;
  updatedByUserId: string;
  updatedAt: string;
};

export enum FormulaType {
  SMART_TEXT = 'SMART_TEXT',
  CEL_EXPRESSION = 'EXPRESSION',
}

export const groupingRuleConfig: Record<
  (typeof supportedProjections)[keyof typeof supportedProjections],
  {
    defaultFallbackRule: GroupingRule;
    settingType: SettingType;
  }
> = {
  [supportedProjections.Ticket]: {
    settingType: SettingType.GroupingRules,
    defaultFallbackRule: {
      id: NEW_DEFAULT_RULE_ID,
      name: 'Default',
      isNew: true,
      grouping: {
        fieldGrouping: {
          fields: ['finding.source_key'],
        },
      },
      entityTitleFormat: '{{uber_findings.title}}',
      defaultFallbackRule: true,
    },
  },
  [supportedProjections.Violation_Tickets]: {
    settingType: SettingType.GroupingRulesAem,
    defaultFallbackRule: {
      id: NEW_DEFAULT_RULE_ID,
      name: 'Default',
      isNew: true,
      grouping: {
        fieldGrouping: {
          fields: ['policy_violation.policy_name'],
        },
      },
      entityTitleFormat: '{{uber_policy_violations.policy_name}}',
      defaultFallbackRule: true,
    },
  },
} as const;
